// extracted by mini-css-extract-plugin
export const pagination = "pagination-module--pagination--3J-bq";
export const button = "pagination-module--button--pSUyN";
export const prev = "pagination-module--prev--1MyPn";
export const next = "pagination-module--next--2VpcX";